export default "__VITE_ASSET__3cd8e8fa__"